window.getViewportTopOffsetConfig = function() {
  const documentElement = document.documentElement;
  return parseInt( window.getComputedStyle( documentElement ).getPropertyValue( '--ck-snippet-viewport-top-offset' ) );
};

export default (
  editorId
) => {
  const invoiceNavigationElement = document.querySelector(editorId)
  if (invoiceNavigationElement) {

    tinymce.init({
      selector: editorId,
      menubar: '',
      plugins: 'table code',
      toolbar: 'undo redo | formatselect | bold italic | ' +
        'alignleft aligncenter alignright alignjustify | indent outdent | ' +
        'table tableinsertdialog tablecellprops tableprops',
      icons_url: '/icons2/default/icons.js',
    });



    /*ClassicEditor
      .create(
        document.querySelector( editorId ),
        {
          toolbar:{
            viewportTopOffset:window.getViewportTopOffsetConfig()
          }
        }
      )
      .then( editor => {
        console.log( editor );
      } )
      .catch( error => {
        console.error( error );
      } );*/
  }
}
